module.exports = __webpack_public_path__ + "img/demo_woman5.0df9ac7f.svg";